// Jul-2026 (User-Wunsch · 451) — Gemeinsame Fahrzeugtyp-Klassifikation für
// ALLE Flows (Inserat-Scan & Eintausch), damit die Erkennung überall identisch
// ist. Ruft den generischen Backend-Endpoint auf; still bei Fehler.
import api from "./api";

export async function classifyVehicleType({ brand, model, vehicle_class }) {
    if (!brand && !model && !vehicle_class) return null;
    try {
        const r = await api.post("/vehicle/classify-type", { brand, model, vehicle_class });
        return r.data || null;
    } catch {
        return null;
    }
}
